<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col cols="6" class="text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">Lista</span>
        <h3 class="page-title d-inline">Indicações</h3>
      </d-col>
      <d-col cols="6" class="text-sm-right mb-0">
        <d-button @click="exportCSV()">Exportar CSV</d-button>
      </d-col>
    </d-row>

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div class="card-header border-bottom d-flex justify-content-around">
            <div class="col-3">
              <h6 class="m-0">Indicações Ativos</h6>
            </div>
            <div class="col-9 p-0">
              <form class="main w-100">
                <d-form-row class="w-100">
                  <d-col cols="4" class="d-flex mb-4 mb-sm-0 justify-content-start">
                    <autocomplete
                      v-if="isAdmin||isCommercial"
                      ref="autocomplete"
                      placeholder="Revendedor"
                      :items="resellers"
                      item-show="name"
                      :on-input="onInput"
                      :on-select="setReseller"
                    ></autocomplete>
                    <d-select
                      v-if="!isAdmin && options.length > 1"
                      v-model="pagination.reseller"
                      :options="options"
                      value-field="id"
                      text-field="name"
                    ></d-select>
                  </d-col>
                  <d-col cols="auto" class="d-flex mb-4 mb-sm-0 justify-content-start">
                    <d-input-group class="d-flex justify-content-left">
                      <d-datepicker v-model="pagination.date_from" placeholder="Data inicial" typeable/>
                      <d-datepicker v-model="pagination.date_to" placeholder="Data final" typeable/>
                      <d-input-group-text slot="append">
                        <i class="material-icons">&#xE916;</i>
                      </d-input-group-text>
                    </d-input-group>
                  </d-col>
                  <d-col>
                    <div class="input-group input-group-seamless ">
                      <div class="input-group-prepend">
                        <div class="input-group-text">
                          <i class="fas fa-search"></i>
                        </div>
                      </div>
                      <input
                        class="navbar-search form-control"
                        type="text"
                        placeholder="Procurar por algo..."
                        aria-label="Search"
                        v-model="pagination.search"
                      >
                    </div>
                  </d-col>
                </d-form-row>
              </form>
            </div>
          </div>
          <div class="card-body p-0 pb-3 text-left">
            <div class="table-overflow">
              <lead-table :leads="leads.list" />
            </div>
            <pagination :total-items="leads.total_items" :pagination.sync="pagination"></pagination>
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Config from '_config';
import { downloadCsvFile, cloneDeep, catchPdf } from '_utils';
import Autocomplete from '_shared/Autocomplete.vue';
import LeadService from '_services/rest/modules/lead';
import Pagination from '_shared/Pagination.vue';
import LeadTable from '../components/LeadListTable.vue';
import { _SET_RESELLER_ } from '../components/LeadModel';

const RESELLERS_OPTIONS = [
  { id: null, name: 'Todos' },
  { id: 'without', name: 'Nenhum associado' },
];

export default {
  name: 'lead-list',
  components: {
    Autocomplete,
    Pagination,
    LeadTable,
  },
  data() {
    return {
      pagination: {
        date_from: null,
        date_to: null,
        search: '',
        reseller: null,
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
      options: [],
    };
  },
  computed: {
    leads() {
      const { leadList } = this.$store.state.lead;
      if (leadList && leadList.list.length) {
        return leadList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
    resellers() {
      const { resellerList } = this.$store.state.reseller;
      if (resellerList && resellerList.list.length) {
        resellerList.list.unshift(cloneDeep(RESELLERS_OPTIONS));
        return resellerList.list;
      }
      return cloneDeep(RESELLERS_OPTIONS);
    },
    isAdmin() {
      const { isAdmin } = this.$store.state.user;
      return isAdmin;
    },
    isCommercial() {
      const { settings } = this.$store.state.user.user;
      return settings.user_type_id === Config.COMMERCIAL_TYPE_ID;
    },
  },
  watch: {
  },
  methods: {
    ...mapActions([
      'checkAdmin',
      'getLeadList',
      'getResellerList',
    ]),
    exportCSV() {
      LeadService.download(this.pagination)
        .then(response => downloadCsvFile(response))
        .catch(error => this.activeAlert({ message: catchPdf(error.message), theme: 'danger' }));
    },
    getResellersOptions() {
      LeadService.getResellersOptions()
        .then(response => {
          if (response.length) {
            this.pagination.reseller = response[0].id;
            this.options = response;
          }
          this.getList();
        });
    },
    getList() {
      this.getLeadList(this.pagination);
    },
    getReseller(name = '') {
      const params = {
        skip: 0,
        take: 10,
        search: name,
      };
      this.getResellerList(params);
    },
    onInput(name) {
      clearTimeout(this.searchTimeoutId);
      this.searchTimeoutId = setTimeout(() => {
        this.getReseller(name);
      }, 500);
    },
    setReseller(reseller) {
      this.pagination.page = 1;
      this.pagination.skip = 0;
      this.pagination.reseller = reseller.id;
    },
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination', pagination => {
      this.$router.push({ params: { page: pagination.page } });
      this.getList();
    });
    this.checkAdmin();

    Events.$on(_SET_RESELLER_, reseller => {
      this.setReseller(reseller);
      this.getLeadList(this.pagination);
    });
    if (this.isAdmin) {
      return this.getList();
    }
    return this.getResellersOptions();
  },

};
</script>

<style lang="scss" scoped>
.vdp-datepicker input {
    height: 38px;
}
</style>
